import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthguardService, AdminguardService } from './../../guards';

import { WidgetconfigComponent } from './widgetconfig/widgetconfig.component';

const AdminRoutes: Routes = [
    {
        path: 'admin',
        canActivate: [AuthguardService],
        canActivateChild: [AdminguardService],
        data: { expectedRole: ['WIMSADM'] }, //Admin Roles
        children: [
            {
                path: 'widgets',
                component: WidgetconfigComponent
            },
        ]
    }
];

@NgModule({
    //imports: [RouterModule.forRoot(AdminRoutes, { enableTracing: true })],
    imports: [RouterModule.forRoot(AdminRoutes)],
    exports: [RouterModule]
})
export class AdminRouting { }


// WEBPACK FOOTER //
// ./src/app/components/admin/admin.routing.ts